import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CollabSpaceStore" */ './lazyIndex')
);

export const lazyParseCollabObject = new LazyAction(lazyModule, m => m.parseCollabObject);
export const lazyIsCollabEnabledInEvent = new LazyAction(lazyModule, m => m.isCollabEnabledInEvent);
export const lazyCreateCollabObject = new LazyAction(lazyModule, m => m.createCollabObject);
export const lazyUpdateMeetingNotes = new LazyAction(lazyModule, m => m.updateMeetingNotes);

// Non lazy utils
export { areCollabSpacesEqual } from './utils/areCollabSpacesEqual';
export { parseCollabSpace } from './utils/parseCollabSpace';
export { shouldCreateCollabObject } from './utils/shouldCreateCollabObject';
export { shouldQueryCollabObject } from './utils/shouldQueryCollabObject';
